import { setLastActivity } from 'helpers/sessionContext';

/**
 * Resets the inactivity timeout by updating the last activity timestamp.
 * This should be called whenever there is meaningful user activity,
 * such as logging in, unlocking the session, or interaction.
 */
export const resetInactivityTimeout = () => {
    setLastActivity();
};
